export default [
    {
        name: 'NR_PC',
        label: 'Número do pedido'
    },
    {
        name: 'CD_FIL',
        label: 'Código da filial'
    },
    {
        name: 'DT_ENTRG',
        label: 'Data da entrega'
    },
    {
        name: 'ID_PROD',
        label: 'Código do produto'
    },
    {
        name: 'NM_PROD',
        label: 'Nome do produto'
    },
    {
        name: 'DT_EMIS',
        label: 'Data da emissão'
    },
    {
        name: 'DT_PREV_ENTRG',
        label: 'Previsão de entrega'
    },
    {
        name: 'QT_ITEM',
        label: 'Quantidade de item'
    },
    {
        name: 'QT_ENTRG',
        label: 'Quantidade entrega'
    },
    {
        name: 'QT_DEVOL',
        label: 'Quantidade devolução'
    },
    {
        name: 'QT_CANC',
        label: 'Quantidade cancelamento'
    },
    {
        name: 'VM_UNIT',
        label: 'Valor unitário'
    },
    {
        name: 'VP_IPI',
        label: 'Percentual IPI'
    },
    {
        name: 'VM_IPI',
        label: 'Valor IPI'
    },

    {
        name: 'VM_DESC',
        label: 'Valor desconto'
    },
    {
        name: 'VP_DESC',
        label: 'Percentual desconto'
    },
    {
        name: 'VM_LIQ',
        label: 'Valor líquido'
    },
    {
        name: 'DS_TIPO_PEDIDO',
        label: 'Tipo do pedido'
    },
    {
        name: 'NR_PRAZO',
        label: 'Prazo'
    },
    {
        name: 'CD_PAGTO',
        label: 'Código do pagamento'
    },
    {
        name: 'CD_FIL_ENTRG',
        label: 'Código da filial entrega'
    },
    {
        name: 'IN_TIPO_PED',
        label: 'Tipo da pendência'
    },
    {
        name: 'DT_SOLIC_ANTEC',
        label: 'Data de antecipação'
    },
    {
        name: 'ITEM_ANTECIPADO',
        label: 'Realizado antecipação'
    },
    {
        name: 'ID_PESSOA',
        label: 'Código da pessoa'
    },
    {
        name: 'NM_PESSOA',
        label: 'Nome da pessoa'
    },
];